<template>
    <Table :headers="headers" :items="paginatedData">
        <template #item-cell.id="{ item, label, header, index }">
            {{ (pagination.currentPage - 1) * pagination.perPage + index }}
        </template>

        <template #item-cell.amaun="{ item, label, header, index }">
           {{ Number(item.amaun  ).toFixed(2)}}
        </template>

        <template #item-cell.tarikh_bayar="{ item, label, header, index }">
           {{ moment(item.tarikh_bayar).format("DD-MM-YYYY h:mm:ss A")}}
        </template>
        <template #item-cell.action="{ item, label, header, index }">
            <w-form @submit.prevent="addNoHm(item)">
                <w-button class="my1 mr0" type="submit">
                    <w-icon> fal fa-file </w-icon>
                </w-button>
            </w-form>
        </template>
    </Table>
    <TablePagination
        :lastPage="getLastPage"
        :currentPage="pagination.currentPage"
        :perPage="pagination.perPage"
        @onClick="onPaginationChange($event)"
    />
</template>

<script>
import Hakmilik from "../Component/Hakmilik";
import moment from "moment";
import Card from "../Component/Card";
import { Inertia } from "@inertiajs/inertia";
import Table from "./Table";
import TablePagination from "./TablePagination";
import { ref, defineComponent, onMounted, watch, computed } from "vue";

export default defineComponent({
    props: {
        cukais: [Object, Array],
    },
    components: {
        Hakmilik,
        Card,
        Table,
        TablePagination,
    },
    created: function () {
        this.moment = moment;
    },
    setup(props) {
        const headers = [
            { label: "Bil", key: "id" },
            { label: "No. Resit", key: "no_resit" },
            { label: "Cara Bayar", key: "keterangan_cara_bayar" },
            { label: "No Rujukan", key: "no_rujukan" },
            { label: "Amaun (RM)", key: "amaun" ,align:"right"},
            { label: "Tarikh Bayar", key: "tarikh_bayar" },
            { label: "Resit Status", key: "keterangan" },
            { label: "Tindakan", key: "action" },
        ];

        const pagination = ref({
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
        });

        const paginatedData = computed(() => {
            const { perPage, currentPage, lastPage } = pagination.value;
            return props.cukais.slice(
                (currentPage - 1) * perPage,
                perPage * currentPage
            );
        });

        const getLastPage = computed(() => {
            return props.cukais.length > 0
                ? Math.ceil(props.cukais.length / pagination.value.perPage)
                : 1;
        });

        function onPaginationChange(e) {
            pagination.value = e.value;
        }

        return {
            headers,
            pagination,
            paginatedData,
            getLastPage,
            onPaginationChange,
        };
    },
    methods: {
        addNoHm(w) {
            const url = `butiran-cukai?no_hm=${w.no_rujukan}`;
            //   console.log(url);
            //  this.$inertia.get(url);
             window.open(url, "_blank");
        },
    },
});
</script>
